import styled from 'styled-components';

export const ScheduledGamesWrapper = styled.div`
  position: relative;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.div`
  color: #414141;
  text-align: center;
  font-family: Oswald;
  font-size: 25px;
  font-style: normal;
  font-weight: 500;
  line-height: 35px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const Subtitle = styled.div`
  color: #717171;
  text-align: center;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
`;

export const TopBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
`;

export const NoGames = styled.div`
  margin-top: 70px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
`;

export const NoGamesTitle = styled.div`
  color: var(--Grayscale-textElementGrey, #414141);
  font-family: Oswald;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 25.2px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
`;

export const NoGamesSubtitle = styled.div`
  color: var(--Grayscale-textElementGrey, #414141);
  text-align: center;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;
